export default "__VITE_ASSET__DRa0heVX__"